// src/services/mensagensErro.js
// Mensagens de erro de conta em linguagem simples: dizem o que aconteceu e o que fazer em seguida.
export function mensagemErroCriarConta(codigo) {
  switch (codigo) {
    case 'auth/email-already-in-use':
      return 'Este e-mail já tem uma conta. Faça login em vez de criar outra.';
    case 'auth/weak-password':
      return 'A senha precisa ter pelo menos 6 caracteres.';
    case 'auth/invalid-email':
      return 'Esse e-mail parece incompleto. Confira se tem @ e o final (ex.: nome@exemplo.com).';
    case 'auth/network-request-failed':
      return 'Sem conexão com a internet. Conecte-se e tente de novo.';
    default:
      return 'Não foi possível criar a conta agora. Confira os dados e tente de novo em instantes.';
  }
}

export function mensagemErroLogin(codigo) {
  switch (codigo) {
    case 'auth/network-request-failed':
      return 'Sem conexão com a internet. Conecte-se e tente de novo.';
    case 'auth/too-many-requests':
      return 'Muitas tentativas seguidas. Aguarde alguns minutos ou use "Esqueci minha senha".';
    default:
      return 'E-mail ou senha incorretos. Confira e tente de novo, ou use "Esqueci minha senha".';
  }
}
